import { c as _c } from "react/compiler-runtime";
import { RiCheckboxCircleFill, RiCloseCircleLine } from '@remixicon/react';
import { cn } from '@/utils/css-class';
import type { CostNameProps, PlanV2 } from '@/types/virtual-lab/pricing';
function FeatureIcon(t0) {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value ? <RiCheckboxCircleFill className="size-4 shrink-0 text-green-600" /> : <RiCloseCircleLine className="size-4 shrink-0 text-neutral-400" />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function CostFeatureRow(t0) {
  const $ = _c(46);
  const {
    feature,
    textColor,
    mutedColor,
    nameWidth,
    costWidth
  } = t0;
  let t1;
  if ($[0] !== feature.subItems) {
    t1 = feature.subItems ?? [];
    $[0] = feature.subItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subItems = t1;
  if (subItems.length === 0) {
    let t2;
    if ($[2] !== nameWidth || $[3] !== textColor) {
      t2 = cn(nameWidth, "font-semibold", textColor);
      $[2] = nameWidth;
      $[3] = textColor;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== feature.name || $[6] !== t2) {
      t3 = <div className={t2}>{feature.name}</div>;
      $[5] = feature.name;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== costWidth || $[9] !== mutedColor) {
      t4 = cn(costWidth, "text-right font-normal", mutedColor);
      $[8] = costWidth;
      $[9] = mutedColor;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== feature.cost || $[12] !== t4) {
      t5 = <div className={t4}>{feature.cost}</div>;
      $[11] = feature.cost;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t3 || $[15] !== t5) {
      t6 = <div className="flex w-full flex-row items-baseline justify-between text-base leading-tight">{t3}{t5}</div>;
      $[14] = t3;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t2;
  if ($[17] !== nameWidth || $[18] !== textColor) {
    t2 = cn(nameWidth, "font-semibold", textColor);
    $[17] = nameWidth;
    $[18] = textColor;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== feature.name || $[21] !== t2) {
    t3 = <div className={t2}>{feature.name}</div>;
    $[20] = feature.name;
    $[21] = t2;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== costWidth || $[24] !== feature.cost || $[25] !== mutedColor) {
    t4 = feature.cost && <div className={cn(costWidth, "text-right font-normal", mutedColor)}>{feature.cost}</div>;
    $[23] = costWidth;
    $[24] = feature.cost;
    $[25] = mutedColor;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== t3 || $[28] !== t4) {
    t5 = <div className="flex w-full flex-row items-baseline justify-between gap-2 text-base leading-tight">{t3}{t4}</div>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== costWidth || $[31] !== mutedColor || $[32] !== nameWidth || $[33] !== subItems || $[34] !== textColor) {
    let t7;
    if ($[36] !== costWidth || $[37] !== mutedColor || $[38] !== nameWidth || $[39] !== textColor) {
      t7 = sub => {
        const unavailable = sub.available === false;
        return <div key={sub._key} className={cn("flex w-full flex-row items-baseline justify-between gap-2 text-sm leading-tight", unavailable && "opacity-40")}><div className={cn(nameWidth, "font-normal", textColor)}>{sub.name}</div><div className={cn(costWidth, "text-right font-normal", mutedColor)}>{unavailable ? "Coming soon" : sub.cost}</div></div>;
      };
      $[36] = costWidth;
      $[37] = mutedColor;
      $[38] = nameWidth;
      $[39] = textColor;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    t6 = subItems.map(t7);
    $[30] = costWidth;
    $[31] = mutedColor;
    $[32] = nameWidth;
    $[33] = subItems;
    $[34] = textColor;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  let t7;
  if ($[41] !== t6) {
    t7 = <div className="flex flex-col gap-0.5 pl-4">{t6}</div>;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  let t8;
  if ($[43] !== t5 || $[44] !== t7) {
    t8 = <div className="flex w-full flex-col gap-1">{t5}{t7}</div>;
    $[43] = t5;
    $[44] = t7;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  return t8;
}
export default function PlanBody(t0) {
  const $ = _c(37);
  const {
    plan,
    isCurrentTier
  } = t0;
  const textColor = isCurrentTier ? "text-white" : "text-primary-9!";
  const mutedColor = isCurrentTier ? "text-primary-4" : "text-primary-6!";
  const dividerColor = isCurrentTier ? "bg-white/60" : "bg-primary-9!";
  let t1;
  if ($[0] !== plan.general_features || $[1] !== textColor) {
    let t2;
    if ($[3] !== textColor) {
      t2 = feature => <div key={feature.label} className="font-title flex flex-row items-center justify-between"><div className={cn("text-base font-normal", textColor)}>{feature.label}</div><FeatureIcon value={feature.value} /></div>;
      $[3] = textColor;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = plan.general_features.map(t2);
    $[0] = plan.general_features;
    $[1] = textColor;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== dividerColor || $[6] !== mutedColor || $[7] !== plan.ai_assistant_features || $[8] !== textColor) {
    t2 = plan.ai_assistant_features.length > 0 && <><div className={cn("my-3 h-px w-full ", dividerColor)} /><div className="flex w-full flex-col"><div className={cn("mb-1 text-lg font-semibold tracking-wide uppercase", mutedColor)}>AI Assistant</div><div className="flex flex-col gap-2">{plan.ai_assistant_features.map(feature_0 => <CostFeatureRow key={feature_0._key} feature={feature_0} textColor={textColor} mutedColor={mutedColor} nameWidth="w-1/3" costWidth="w-2/3" />)}</div></div></>;
    $[5] = dividerColor;
    $[6] = mutedColor;
    $[7] = plan.ai_assistant_features;
    $[8] = textColor;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== dividerColor || $[11] !== mutedColor || $[12] !== plan.build_features || $[13] !== textColor) {
    t3 = plan.build_features.length > 0 && <><div className={cn("my-3 h-px w-full", dividerColor)} /><div className="flex w-full flex-col"><div className={cn("mb-1 text-lg font-semibold tracking-wide uppercase", mutedColor)}>Build</div><div className="flex flex-col gap-2">{plan.build_features.map(feature_1 => <CostFeatureRow key={feature_1._key} feature={feature_1} textColor={textColor} mutedColor={mutedColor} nameWidth="w-1/2" costWidth="w-1/2" />)}</div></div></>;
    $[10] = dividerColor;
    $[11] = mutedColor;
    $[12] = plan.build_features;
    $[13] = textColor;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== dividerColor || $[16] !== mutedColor || $[17] !== plan.simulate_features || $[18] !== textColor) {
    t4 = plan.simulate_features.length > 0 && <><div className={cn("my-3 h-px w-full", dividerColor)} /><div className="flex w-full flex-col"><div className={cn("mb-1 text-lg font-semibold tracking-wide uppercase", mutedColor)}>Simulate</div><div className="flex flex-col gap-2">{plan.simulate_features.map(feature_2 => <CostFeatureRow key={feature_2._key} feature={feature_2} textColor={textColor} mutedColor={mutedColor} nameWidth="w-2/5" costWidth="w-3/5" />)}</div></div></>;
    $[15] = dividerColor;
    $[16] = mutedColor;
    $[17] = plan.simulate_features;
    $[18] = textColor;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== dividerColor || $[21] !== mutedColor || $[22] !== plan.notebooks_features || $[23] !== textColor) {
    t5 = plan.notebooks_features.length > 0 && <><div className={cn("my-3 h-px w-full", dividerColor)} /><div className="flex w-full flex-col"><div className={cn("mb-1 text-lg font-semibold tracking-wide uppercase", mutedColor)}>Notebooks</div><div className="flex flex-col gap-2">{plan.notebooks_features.map(feature_3 => <CostFeatureRow key={feature_3._key} feature={feature_3} textColor={textColor} mutedColor={mutedColor} nameWidth="w-2/5" costWidth="w-3/5" />)}</div></div></>;
    $[20] = dividerColor;
    $[21] = mutedColor;
    $[22] = plan.notebooks_features;
    $[23] = textColor;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== dividerColor || $[26] !== mutedColor || $[27] !== plan.support || $[28] !== textColor) {
    t6 = plan.support.length > 0 && <><div className={cn("my-3 h-px w-full", dividerColor)} /><div className="flex w-full flex-col"><div className={cn("mb-1 text-lg font-semibold tracking-wide uppercase", mutedColor)}>Support</div><div className="flex flex-col gap-2">{plan.support.map(feature_4 => <div key={feature_4.label} className="flex w-full flex-row items-baseline justify-between text-base leading-tight"><div className={cn("text-base font-normal", textColor)}>{feature_4.label}</div><FeatureIcon value={feature_4.value} /></div>)}</div></div></>;
    $[25] = dividerColor;
    $[26] = mutedColor;
    $[27] = plan.support;
    $[28] = textColor;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== t1 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6) {
    t7 = <div className="relative mt-10"><div className="flex flex-col gap-2">{t1}{t2}{t3}{t4}{t5}{t6}</div></div>;
    $[30] = t1;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  return t7;
}